<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
    <path
      d="M20.9384 11.6127L1.99401 0.848869C1.32737 0.470095 0.5 0.95159 0.5 1.71833V8.7362C0.5 9.18715 0.80182 9.58231 1.23688 9.70097L11.5 12.5L1.32111 14.3507C0.845624 14.4372 0.5 14.8513 0.5 15.3346V22.8155C0.5 23.5745 1.31248 24.0568 1.97885 23.6934L20.9232 13.3601C21.6112 12.9848 21.6198 11.9999 20.9384 11.6127Z"
      :fill="color"
    />
  </svg>
</template>
<script>
import Vue from 'vue';
export default Vue.extend({
  props: {
    color: {
      type: String,
      default: '#dedee4',
    },
  },
});
</script>
